<template>
  <div id="app">
    <Navbar @open-form="showForm = true" />
    <router-view />
    <ContactForm v-if="showForm" @close="showForm = false" />
    <FooterContact />
    <CookieBanner />

    <div class="social-float">
      <a
        href="https://www.facebook.com/profile.php?id=61554863440673&sk=photos"
        target="_blank"
        class="social-btn fb"
        aria-label="Facebook"
      >
        <i class="fab fa-facebook-f"></i>
      </a>
      <a
        href="https://www.instagram.com/autoheaven.ro/"
        target="_blank"
        class="social-btn ig"
        aria-label="Instagram"
      >
        <i class="fab fa-instagram"></i>
      </a>
      <a
        href="https://www.tiktok.com/@autoheaven.ro"
        target="_blank"
        class="social-btn tt"
        aria-label="TikTok"
      >
        <i class="fab fa-tiktok"></i>
      </a>
      <a
        href="https://api.whatsapp.com/send/?phone=40773383914&text&type=phone_number&app_absent=0"
        target="_blank"
        class="social-btn wa"
        aria-label="WhatsApp"
      >
        <i class="fab fa-whatsapp"></i>
      </a>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import ContactForm from "@/components/ContactForm.vue";
import FooterContact from "@/components/FooterContact.vue";
import CookieBanner from "@/components/CookieBanner.vue";

export default {
  name: "App",
  components: {
    Navbar,
    ContactForm,
    FooterContact,
    CookieBanner,
  },
  data() {
    return {
      showForm: false,
    };
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  background-color: black;
  color: white;
  overflow-x: hidden;
}

.social-float {
  position: fixed;
  top: 150px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 9999;
}

.social-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-color: rgba(20, 20, 20, 0.8);
  color: white;
  font-size: 20px;
  text-decoration: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  backdrop-filter: blur(3px);
}

.social-btn:hover {
  transform: translateY(-3px) scale(1.1);
  color: white;
}

/* Culori personalizate pentru hover */
.fb:hover {
  background-color: #1877f2;
}
.ig:hover {
  background: linear-gradient(
    45deg,
    #f09433,
    #e6683c,
    #dc2743,
    #cc2366,
    #bc1888
  );
}
.tt:hover {
  background-color: black;
  color: #69c9d0;
}
.wa:hover {
  background-color: #25d366;
  color: white;
}

/* Responsiv pentru mobil */
@media (max-width: 768px) {
  .social-float {
    bottom: 50px;
    top: auto;
    right: 15px;
    flex-direction: row;
    gap: 8px;
  }

  .social-btn {
    width: 35px;
    height: 35px;
    font-size: 16px;
    background-color: goldenrod;
    color: black;
  }

  .social-btn:hover {
    opacity: 0.8;
    transform: none;
  }
}
</style>
